/**
 * @(#)2019/11/14.
 * 缓存控制器
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

// Cookie对象
import Cookie from "js-cookie";
// 站点配置 test
import config from "config/Config";
import { get } from ".";

// 删除Cookie
const clearCookie = () => {
  if (!config.cookie) {
    return false;
  }
  Object.keys(config.cookie).map((key, idx) => {
    Cookie.remove(config.cookie[key]);
  });
  return true;
};

class DB {
  static storeType = "local";

  /**
   * 从缓存提取值
   *
   * @static
   * @param {string} key
   * @returns
   * @memberof DB
   */
  static get(key, storeType = "local") {
    const type = get(DB, "storeType", storeType);
    const store = type === "local" ? localStorage : sessionStorage;
    let localValue = store.getItem(key);
    return localValue ? JSON.parse(localValue) : null;
  }

  /**
   *
   * 写入缓存
   * @static
   * @param {string} key 键
   * @param {string} value 值
   * @memberof DB
   */
  static set(key, value, storeType = "local") {
    const type = get(DB, "storeType", storeType);
    const store = type === "local" ? localStorage : sessionStorage;
    store.setItem(key, JSON.stringify(value));
  }
}

export { clearCookie, DB };



// WEBPACK FOOTER //
// ./src/yx-widget/utils/DB.js